<template>
	<div class="action-flow-node action-flow-node-trigger" style="height: 280px;">
		<div class="action-flow-title">Context Menu Trigger</div>
		<div class="action-flow-hint">Flow starts from here when a context menu is clicked.</div>
		
		<ActionParamHint label="Component" hint="Which component on what page has a context menu added to it?" param-class="param-config"
			param-input-type="select"  param-input-label="Component" @param-change="handleParamChange"
			:param-input-options="[{ value: 'ux-list', label: 'List' }, { value: 'ux-grid', label: 'Grid' }]"
			:param-input-value="parameters.component"
		/>
		<ActionParamHint label="Label" hint="What is the label of the menu item?" param-class="param-config"
			param-input-type="text" param-input-label="Label" @param-change="handleParamChange"
			:param-input-value="parameters.label"
		/>
		<ActionParamHint label="Icon" hint="What icon to show for the menu item?" param-class="param-config"
			param-input-type="icon" param-input-label="Icon" @param-change="handleParamChange"
			:param-input-options="[]"
			:param-input-value="parameters.icon"
		/>
		<ActionParamHint label="Mote" hint="Single mote selected, or the first one." param-class="param-src" />
		<ActionParamHint label="Component" hint="Parent component of the context menu." param-class="param-src" />
		
		<Handle type="source" id="src-mote" :position="Position.Right" style="top: 215px;" />
		<Handle type="source" id="src-selection" :position="Position.Right" style="top: 255px;" />
	</div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values - initialize from node data if available
const parameters = ref({
	component: '',
	label: '',
	icon: '',
});

// Watch for changes in nodeData and update parameters accordingly
watch(nodeData, (newNodeData) => {
	if (newNodeData) {
		parameters.value = {
			component: newNodeData.data?.component || '',
			label: newNodeData.data?.label || '',
			icon: newNodeData.data?.icon || '',
		};
	}
}, { immediate: true });

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	let key = paramData.label.toLowerCase();
	if (!(key in parameters.value)) {
		console.error(`Unknown parameter label: ${paramData.label}`);
		return;
	}
	parameters.value[key] = paramData.value;
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}

</script>